import { Link } from "@inertiajs/react"

const RegularButton = ({ className = '', disabled = false, children, ...props }) => {
  return (
    <Link
        {...props}
        as='button'
        className={
            `inline-flex items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest focus:outline-none focus:ring-2 focus:ring-offset-2 transition ease-in-out duration-150 ${
                disabled && 'opacity-25'
            } ` + className
        }
        disabled={disabled}
    >
        {children}
    </Link>
  )
}

export default RegularButton
